/* eslint-disable @typescript-eslint/naming-convention */
import React, { memo, useCallback, useState } from "react";

// components
import MRODeliverySpeedHalfCard from "./MRODeliverySpeedHalfCard";
import MRORestaurantDeliveryRow from "./MRORestaurantDeliveryRow";

// types
import { MROChildCart } from "@swiggy-private/cart-types";

// helpers
import { getMROChildCartRestaurantId } from "@cart-client/helpers/MROFoodCart";
import { isSelfDeliveryRx, isChildDeliverySpeedDisabled } from "./helpers/mro";

// styles
import { RestaurantListContainer } from "./styles";

export interface MRODeliverySpeedRestaurantListProps {
    selected: MROChildCart[];
}

function MRODeliverySpeedRestaurantList({ selected }: MRODeliverySpeedRestaurantListProps) {
    const [activeChild, setActiveChild] = useState<MROChildCart | null>(null);
    const [isHalfCardOpen, setIsHalfCardOpen] = useState(false);

    const handleChangeDelType = useCallback((child: MROChildCart) => {
        if (isSelfDeliveryRx(child) || isChildDeliverySpeedDisabled(child)) {
            return;
        }
        setActiveChild(child);
        setIsHalfCardOpen(true);
    }, []);

    const closeHalfCard = useCallback(() => {
        setIsHalfCardOpen(false);
    }, []);

    return (
        <>
            <RestaurantListContainer>
                {selected.map((child, index) => (
                    <MRORestaurantDeliveryRow
                        key={getMROChildCartRestaurantId(child)}
                        child={child}
                        isFirstItem={index === 0}
                        isLastItem={index === selected.length - 1}
                        onChangeDelType={handleChangeDelType}
                    />
                ))}
            </RestaurantListContainer>

            {activeChild && (
                <MRODeliverySpeedHalfCard
                    key={getMROChildCartRestaurantId(activeChild)}
                    cart={activeChild}
                    isOpen={isHalfCardOpen}
                    onClose={closeHalfCard}
                />
            )}
        </>
    );
}

export default memo(MRODeliverySpeedRestaurantList);
